module.exports = __webpack_public_path__ + "img/GALLERY-ERTIGA-3.5a40ec5c.jpg";